import query from 'query-string';

// internal
import { getToken, clearToken } from '@app/utils/localStorage';
import history from '@app/components/router/history';

export const endpoint = (path: string) => `${process.env.REACT_APP_BACK_API_URL}${path}`;

export const headers = (headers?: { [key: string]: string }, auth: boolean = true) => {
  const option: { [key: string]: string } = {};

  if (auth) {
    option['Authorization'] = `Bearer ${getToken()}`;
  }

  return {
    headers: {
      ...option,
      ...headers,
    },
  };
};

export const handleError = (error: any) => {
  const err = convertErrorToResponse(error);
  switch (err?.code) {
    case 'KS002':
    case 'KS070':
      clearToken();
      history.push('/login');
      break;
    default:
      if (process.env.REACT_APP_DEBUG_MODE) {
        console.error(error);
      }
      break;
  }

  return err;
};

export const convertErrorToResponse = (error: any) => {
  return error?.response?.data;
};

export const getQueryString = <QueryData = {}>(): QueryData => {
  return query.parse(window.location.search) as any;
};
